import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@Component({
  selector: 'app-logs-latency-modal',
  styleUrl: './logs-latency-modal.component.scss',
  templateUrl: './logs-latency-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIcon,
    NgxJsonViewerModule
  ],
})
export class LogsLatencyModalComponent {

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ){
  }

  ngAfterViewInit():void {
  }
  
  onSubmit() {
    this.dialogRef.close("success")
  }
}


